export enum SearchFilterOption {
	All = 'all',
	Applications = 'applications',
	Desktops = 'desktop',
}
